<template>
  <DpplHeaderFooterContent class="editor-layout-container">
    <template #header>
      <section class="full-width-header" aria-label="Job actions">
        <slot name="full-width-header" />
      </section>
    </template>

    <DpplHeaderFooterContent
      v-if="sideBySideView"
      class="w-100"
    >
      <div class="w-50">
        <slot name="side-revision" />
      </div>
      <div class="w-50">
        <DpplHeaderFooterContent>
          <template #footer>
            <div class="content-footer">
              <slot name="content-footer" />
            </div>
          </template>
          <slot name="content" />
        </DpplHeaderFooterContent>
      </div>
    </DpplHeaderFooterContent>

    <DpplHeaderFooterContent
      v-if="!sideBySideView"
      class="editor-layout mx-auto w-100"
    >
      <template #header>
        <slot name="header" />
      </template>

      <section class="w-25" aria-label="Guidance">
        <slot name="left" />
      </section>

      <DpplHeaderFooterContent class="w-50 h-100 overflow-x-hidden">
        <section class="w-100 content" aria-label="Job editor">
          <slot name="content" />
        </section>

        <template #footer>
          <div class="content-footer">
            <slot name="content-footer" />
          </div>
        </template>
      </DpplHeaderFooterContent>

      <section class="w-25" aria-label="Right sidebar">
        <slot name="right" />
      </section>
    </DpplHeaderFooterContent>
  </DpplHeaderFooterContent>
</template>

<script setup>
import DpplHeaderFooterContent from '@ui/components/general/DpplHeaderFooterContent/DpplHeaderFooterContent.vue';

defineProps({
  sideBySideView: {
    type: [Boolean, String],
    default: false,
  },
});
</script>

<style scoped lang="less">
.editor-layout {
  max-width: 1800px;
}

.full-width-header {
  border-bottom: 1px solid @stroke-default;
}

.content-footer {
  border: 1px solid @stroke-default;
}

.content {
  border-left: 1px solid @stroke-default;
  border-right: 1px solid @stroke-default;
}
</style>
